import styled from "styled-components"
import { colors } from "../themes/colors"

export const AboutPageBody = styled.main`
  background: ${colors.c_white[50]};
`
